<div class="blade-wrapper">
  <div class="blade-header">
    <div  class="blade-tools">
        <app-toolbar [toolbar]="toolbar">
            <ng-template 
              toolbarToolDef="confirm" let-tool>
              <ng-container  *ngIf="tool.hasButtonsToShow">
              <button mat-button
                      data-cy="button"
                      class="datex-button"
                      [disabled]="tool.control.readOnly"
                      [ngStyle]="tool.control.styles.style"
                      [ngClass]="tool.control.styles.classes"
                      [matTooltip]="tool.control.tooltip"
                      matTooltipClass="datex-control-tooltip"
                      (click)="on_confirm_clicked($event)"
                      >
                <div class="button-label">
                  <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                    <div class="button-icon">
                      <i data-cy="button-icon" class="datex-default-spinner"></i>
                    </div>
                  </ng-container>
                  <ng-template #showIcon>
                    <div class="button-icon">
                      <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                    </div>
                  </ng-template>
                  <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                </div>
              
              </button>
              </ng-container>
            </ng-template>
            <ng-template 
              toolbarToolDef="cancel" let-tool>
              <ng-container  *ngIf="tool.hasButtonsToShow">
              <button mat-button
                      data-cy="button"
                      class="datex-button"
                      [disabled]="tool.control.readOnly"
                      [ngStyle]="tool.control.styles.style"
                      [ngClass]="tool.control.styles.classes"
                      [matTooltip]="tool.control.tooltip"
                      matTooltipClass="datex-control-tooltip"
                      (click)="on_cancel_clicked($event)"
                      >
                <div class="button-label">
                  <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                    <div class="button-icon">
                      <i data-cy="button-icon" class="datex-default-spinner"></i>
                    </div>
                  </ng-container>
                  <ng-template #showIcon>
                    <div class="button-icon">
                      <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                    </div>
                  </ng-template>
                  <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                </div>
              
              </button>
              </ng-container>
            </ng-template>
        </app-toolbar>
    </div>
    <ng-content></ng-content>
  </div>
  <div class="blade-content">
    <div class="datex-form">
      <ng-container *ngIf="initialized ">
        <div [formGroup]="formGroup"
             class="formdata">
                <div data-cy="fieldset-id-header"
                     *ngIf="!fieldsets.header.hidden && !fieldsets.header.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.header.collapsible }">
                    <div *ngIf="!fieldsets.header.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.header.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.header.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.header.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.header.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.header.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.header.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-allow_duplicate_strategies" *ngIf="!fields.allow_duplicate_strategies.hidden && !fields.allow_duplicate_strategies.removed" 
                            class="field-container standard {{fields.allow_duplicate_strategies.invalid ? 'invalid' : ''}}"
                            [ngStyle]="fields.allow_duplicate_strategies.styles.style"
                            [ngClass]="fields.allow_duplicate_strategies.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.allow_duplicate_strategies.label + (fields.allow_duplicate_strategies.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.allow_duplicate_strategies.label}}<span *ngIf="fields.allow_duplicate_strategies.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <mat-slide-toggle data-cy="slideToggle" formControlName="allow_duplicate_strategies"
                                      color="primary"
                                      class="datex-toggle"
                                      [ngStyle]="fields.allow_duplicate_strategies.control.styles.style"
                                      [ngClass]="fields.allow_duplicate_strategies.control.styles.classes"
                                      [matTooltip]="fields.allow_duplicate_strategies.control.tooltip"
                                      matTooltipClass="datex-control-tooltip">{{fields.allow_duplicate_strategies.control.label}}</mat-slide-toggle>
                        <ng-container *ngIf="fields.allow_duplicate_strategies.invalid">
                          <ng-container *ngFor="let error of fields.allow_duplicate_strategies.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-projects_inherit_template_rules" *ngIf="!fields.projects_inherit_template_rules.hidden && !fields.projects_inherit_template_rules.removed" 
                            class="field-container standard {{fields.projects_inherit_template_rules.invalid ? 'invalid' : ''}}"
                            [ngStyle]="fields.projects_inherit_template_rules.styles.style"
                            [ngClass]="fields.projects_inherit_template_rules.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.projects_inherit_template_rules.label + (fields.projects_inherit_template_rules.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.projects_inherit_template_rules.label}}<span *ngIf="fields.projects_inherit_template_rules.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <mat-slide-toggle data-cy="slideToggle" formControlName="projects_inherit_template_rules"
                                      color="primary"
                                      class="datex-toggle"
                                      [ngStyle]="fields.projects_inherit_template_rules.control.styles.style"
                                      [ngClass]="fields.projects_inherit_template_rules.control.styles.classes"
                                      [matTooltip]="fields.projects_inherit_template_rules.control.tooltip"
                                      matTooltipClass="datex-control-tooltip">{{fields.projects_inherit_template_rules.control.label}}</mat-slide-toggle>
                        <ng-container *ngIf="fields.projects_inherit_template_rules.invalid">
                          <ng-container *ngFor="let error of fields.projects_inherit_template_rules.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-max_billing_task_age_in_days" *ngIf="!fields.max_billing_task_age_in_days.hidden && !fields.max_billing_task_age_in_days.removed" 
                            class="field-container standard {{fields.max_billing_task_age_in_days.invalid ? 'invalid' : ''}}"
                            [ngStyle]="fields.max_billing_task_age_in_days.styles.style"
                            [ngClass]="fields.max_billing_task_age_in_days.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.max_billing_task_age_in_days.label + (fields.max_billing_task_age_in_days.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.max_billing_task_age_in_days.label}}<span *ngIf="fields.max_billing_task_age_in_days.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="max_billing_task_age_in_days"
                                matInput
                                numberBox
                                [format]="fields.max_billing_task_age_in_days.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{fields.max_billing_task_age_in_days.control.readOnly ? 'readonly ' : ''}}"
                                placeholder="{{fields.max_billing_task_age_in_days.control.placeholder}}"
                                [ngStyle]="fields.max_billing_task_age_in_days.control.styles.style"
                                [ngClass]="fields.max_billing_task_age_in_days.control.styles.classes"
                                [matTooltip]="fields.max_billing_task_age_in_days.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.max_billing_task_age_in_days.invalid">
                          <ng-container *ngFor="let error of fields.max_billing_task_age_in_days.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-max_invoice_age_in_days" *ngIf="!fields.max_invoice_age_in_days.hidden && !fields.max_invoice_age_in_days.removed" 
                            class="field-container standard {{fields.max_invoice_age_in_days.invalid ? 'invalid' : ''}}"
                            [ngStyle]="fields.max_invoice_age_in_days.styles.style"
                            [ngClass]="fields.max_invoice_age_in_days.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.max_invoice_age_in_days.label + (fields.max_invoice_age_in_days.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.max_invoice_age_in_days.label}}<span *ngIf="fields.max_invoice_age_in_days.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="max_invoice_age_in_days"
                                matInput
                                numberBox
                                [format]="fields.max_invoice_age_in_days.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{fields.max_invoice_age_in_days.control.readOnly ? 'readonly ' : ''}}"
                                placeholder="{{fields.max_invoice_age_in_days.control.placeholder}}"
                                [ngStyle]="fields.max_invoice_age_in_days.control.styles.style"
                                [ngClass]="fields.max_invoice_age_in_days.control.styles.classes"
                                [matTooltip]="fields.max_invoice_age_in_days.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.max_invoice_age_in_days.invalid">
                          <ng-container *ngFor="let error of fields.max_invoice_age_in_days.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-log_level" *ngIf="!fields.log_level.hidden && !fields.log_level.removed" 
                            class="field-container standard {{fields.log_level.invalid ? 'invalid' : ''}}"
                            [ngStyle]="fields.log_level.styles.style"
                            [ngClass]="fields.log_level.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.log_level.label + (fields.log_level.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.log_level.label}}<span *ngIf="fields.log_level.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="log_level"
                                matInput
                                numberBox
                                [format]="fields.log_level.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{fields.log_level.control.readOnly ? 'readonly ' : ''}}"
                                placeholder="{{fields.log_level.control.placeholder}}"
                                [ngStyle]="fields.log_level.control.styles.style"
                                [ngClass]="fields.log_level.control.styles.classes"
                                [matTooltip]="fields.log_level.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.log_level.invalid">
                          <ng-container *ngFor="let error of fields.log_level.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
                  </div>
                </div>
              </div>
      </ng-container>

    </div>
  </div>
</div>